<template>
    <div class="ui-avatar">
        <img src="@/assets/user-icon.jpg" class="ui-avatar__img" alt="User" />
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.ui-avatar {
    flex-shrink: 0;

    &__img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid $gray100;
    }
}
</style>
